import _ from 'lodash';

const $ = window.jQuery;
const Pikaday = require('pikaday');
const moment = require('moment');

$(() => {
    if (!$('body').hasClass('page-template-template-calendar-home-alt')) {
        return;
    }

    let skipUpdate = false;

    const $outer = $('.calendar-home');

    const $filters = $('.calendar-home-alt__filters');
    const $dayIncrementers = $('.calendar-home-alt__filters__days__btn');
    const $dayLabel = $('.calendar-home-alt__filters__days__date');
    const $clearDay = $('.calendar-home-alt__filters__clear-date');

    const daysOfWeek = [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
    ];
    const closedDays = JSON.parse($('#closed-days')[0].innerHTML);

    let incrementing = false;

    let filters = {
        date: false,
        type: false,
    };

    const sliderArgs = appendArrows => ({
        infinite: false,
        appendArrows,
        prevArrow: `<button class="bleeding-slider__button slick-prev"><i class="icon-arrow-left"></i></button>`,
        nextArrow: `<button class="bleeding-slider__button slick-next"><i class="icon-arrow-right"></i></button>`,
        slidesToShow: 3,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                },
            },
        ],
    });

    let $desktopFilters = $(
        '.calendar-home-alt__filters .aam__select-input, #specific-date-desktop',
    );

    let $date_pickers = $('input[type="text"][name="specific-date"]');
    let mobile_filters_active = false;
    let filtering = false;
    let filtered = false;

    const $unfilteredEvents = $('.calendar-home__event-feeds').first();
    const $filteredEvents = $('.calendar-home__filtered-events').first();

    const offset = $unfilteredEvents.attr('data-offset');
    const post_url = $unfilteredEvents.attr('data-post-url');
    const card_url = $unfilteredEvents.attr('data-card-url');

    let $mobile_filters = $('.event-filters__mobile');
    const $mobile_filter_apply = $('.event-filters__mobile-apply-button');
    const $mobile_filter_toggle = $(
        '.event-filters__mobile-filters--toggle,.event-filters__mobile-close',
    );

    let pickers = [];

    _.each($date_pickers, picker => {
        const $picker = $(picker);

        pickers.push(
            new Pikaday({
                field: $picker[0],
                bound: false,
                format: 'YYYY-M-D',
                keyboardInput: false,
                onSelect: date => {
                    const day = date.getDate();
                    const month = date.getMonth() + 1;
                    const year = date.getFullYear();
                    const is_mobile = !$picker.is('#specific-date-desktop');

                    filters['date'] = { day, month, year };

                    const placeholder = $(
                        '[data-placeholder="Filter by date"] > .aam__select-placeholder',
                    ).first();

                    placeholder.html(`${month}/${day}/${year}`);

                    $dayLabel.html(
                        moment(`${month}-${day}-${year}`, 'MM-DD-YYYY').format(
                            'MMMM D, YYYY',
                        ),
                    );

                    if (
                        !is_mobile &&
                        $picker.closest('.aam__select.aam__select--expanded')
                            .length
                    ) {
                        setTimeout(
                            () =>
                                $picker
                                    .closest(
                                        '.aam__select.aam__select--expanded',
                                    )[0]
                                    .click(),
                            250,
                        );
                        if (skipUpdate) {
                            skipUpdate = false;
                            return;
                        } else {
                            $filteredEvents.trigger('filterChange');
                        }
                    } else if (is_mobile && incrementing) {
                        if (skipUpdate) {
                            skipUpdate = false;
                            return;
                        } else {
                            $filteredEvents.trigger('filterChange');
                            incrementing = false;
                        }
                    }
                },
                i18n: {
                    previousMonth: 'Previous Month',
                    nextMonth: 'Next Month',
                    months: [
                        'January',
                        'February',
                        'March',
                        'April',
                        'May',
                        'June',
                        'July',
                        'August',
                        'September',
                        'October',
                        'November',
                        'December',
                    ],
                    weekdays: [
                        'Sunday',
                        'Monday',
                        'Tuesday',
                        'Wednesday',
                        'Thursday',
                        'Friday',
                        'Saturday',
                    ],
                    weekdaysShort: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
                },
            }),
        );

        window.pickers = pickers;

        const outer = $picker
            .parent()
            .parent()
            .parent()
            .parent();

        outer.trigger('update-height');
    });

    $mobile_filter_toggle.on('click', () => {
        if (!mobile_filters_active) {
            $mobile_filters.addClass(
                'event-filters__mobile--active animated fadeInUpBig',
            );
            $mobile_filters.one('animationend', () => {
                mobile_filters_active = true;
                $mobile_filters.removeClass('animated fadeInUpBig');
            });
        } else {
            $mobile_filters.addClass('animated fadeOutDownBig');
            $mobile_filters.one('animationend', () => {
                mobile_filters_active = false;
                $mobile_filters.removeClass(
                    'animated event-filters__mobile--active  fadeOutDownBig',
                );
            });
        }
    });

    function hideUnfilteredEvents() {
        if (!$unfilteredEvents.is(':visible')) {
            return;
        }

        $unfilteredEvents.addClass('animated fadeOutUp');
        $unfilteredEvents.one('animationend', () =>
            $unfilteredEvents.removeClass('--active animated fadeOutUp'),
        );
    }

    function resetEvents() {
        $outer.removeClass('--no-events-no-date');
        $outer.removeClass('--no-events');
        $outer.removeClass('--closed');

        if ($filteredEvents.hasClass('--active')) {
            $filteredEvents.addClass('animated fadeOutUp');
            $filteredEvents.one('animationend', () => {
                $filteredEvents.removeClass('--active animated fadeOutUp');
                $unfilteredEvents.addClass('--active animated fadeInUp');

                $outer.find('.card-slider__slider').slick('refresh');

                $unfilteredEvents.one('animationend', () => {
                    $unfilteredEvents
                        .find('.card-slider__card')
                        .removeClass('animated fadeInUp');

                    setTimeLinks();

                    filtering = false;

                    $outer.removeClass('--loading');
                });
            });
        } else {
            $unfilteredEvents.addClass('--active animated fadeInUp');

            $outer.find('.card-slider__slider').slick('refresh');

            $unfilteredEvents.one('animationend', () => {
                $unfilteredEvents
                    .find('.card-slider__card')
                    .removeClass('animated fadeInUp');

                setTimeLinks();

                filtering = false;

                $outer.removeClass('--loading');
            });
        }
    }

    function queryEvents(url, body) {
        $.post(url, body).done(cards => {
            const { day, month, year } = filters.date;
            const dayOfWeek = moment(
                `${year}-${month}-${day}`,
                'YYYY-MM-DD',
            ).isoWeekday();
            const isClosed = closedDays.includes(
                daysOfWeek[parseInt(dayOfWeek)],
            );

            if (isClosed) {
                $outer.addClass('--closed');
            } else {
                $outer.removeClass('--closed');
            }

            if (!cards.length && filters.date) {
                filtering = false;

                if (!isClosed) {
                    $outer.addClass('--no-events');
                    $outer.removeClass('--no-events-no-date');
                    $outer.removeClass('--closed');
                }

                $outer.removeClass('--loading');
            } else if (!cards.length && !filters.date) {
                $outer.addClass('--no-events-no-date');
                filtering = false;
                $outer.removeClass('--no-events');
                $outer.removeClass('--loading');
                $outer.removeClass('--closed');
            } else {
                $.post(card_url, { cards }).done(html => {
                    $outer.removeClass('--no-events');
                    $outer.removeClass('--no-events-no-date');

                    html = html.replaceAll(
                        'card-feed__card',
                        'card-slider__card',
                    );

                    $filteredEvents
                        .find('.card-slider__slider')
                        .slick('unslick');

                    $filteredEvents.find('.card-slider__slider').html(html);

                    $filteredEvents
                        .find('.card-slider__slider')
                        .slick(
                            sliderArgs(
                                $filteredEvents.find('.card-slider__arrows'),
                            ),
                        );

                    const maxCards = window.innerWidth >= 1024 ? 3 : 2;
                    if (cards.length > maxCards) {
                        $filteredEvents.find('.card-slider__arrows').show();
                    } else {
                        $filteredEvents.find('.card-slider__arrows').hide();
                    }

                    $filteredEvents.one('animationend', () =>
                        $filteredEvents.removeClass('animated fadeInUp'),
                    );
                    $filteredEvents.addClass('--active animated fadeInUp');

                    filtering = false;

                    $outer.removeClass('--loading');

                    setTimeLinks();
                });
            }
        });
    }

    function filterEvents(url, body = {}) {
        if ($filteredEvents.hasClass('--active')) {
            $filteredEvents.addClass('animated fadeOutUp');
            $filteredEvents.one('animationend', () => {
                $filteredEvents.removeClass(' --active animated fadeOutUp'); // --active
                queryEvents(url, body);
            });
        } else {
            queryEvents(url, body);
        }
    }

    function setTimeLinks() {
        _.each($('.card-feed__card--event'), event => {
            const $event = $(event);
            const $links = $event.find('a').not('.card__tag');
            const time = $event.attr('data-time');

            if (time) {
                _.each($links, link => {
                    const $link = $(link);
                    const url = $link.attr('href');

                    if (!url.includes('?time') && !url.includes('?')) {
                        $link.attr('href', `${url}?time=${time}`);
                    } else if (!url.includes('?time') && url.includes('?')) {
                        $link.attr('href', `${url}&time=${time}`);
                    }
                });
            }
        });
    }

    _.each($desktopFilters, filter => {
        const $filter = $(filter);
        $filter.on('change', function(e) {
            if ($(this).attr('name') !== 'specific-date') {
                filters[$(this).attr('name')] = $(this)
                    .val()
                    .trim();
                $filteredEvents.trigger('filterChange');
            }
        });
    });

    $filteredEvents.on('filterChange', () => {
        if (filtering) {
            return;
        }

        $outer.addClass('--loading');

        filtering = true;

        const { date, type } = filters;
        let body = {};

        if (date) {
            const { day, month, year } = date;
            body['start'] = `${year}-${month}-${day} 00:00:00`;
            body['end'] = `${year}-${month}-${day + 1} 00:00:00`;

            if (!$filters.hasClass('--date-active')) {
                $filters.addClass('--date-active');
            }
        } else if ($filters.hasClass('--date-active')) {
            $filters.removeClass('--date-active');
        }

        if (!date) {
            $(
                '[data-placeholder="Filter by date"] > .aam__select-placeholder',
            ).html(
                $('[data-placeholder="Filter by date"').attr(
                    'data-placeholder',
                ),
            );
        }

        if (type) {
            body['tax_query'] = {
                parameters: [
                    {
                        taxonomy: 'aam__event_type',
                        terms: type,
                    },
                ],
            };
        }

        if (date || type) {
            filtered = true;
        } else {
            filtered = false;
        }

        if (filtered) {
            hideUnfilteredEvents();
        }

        if (!date && !type) {
            resetEvents();
        } else if (!date) {
            const offset = 30;
            filterEvents(`${post_url}${offset}`, body);
        } else {
            filterEvents(post_url, body);
        }
    });

    $mobile_filter_apply.on('click', () => {
        const type = $mobile_filters.find('input[name="type"]:checked').val();

        if (type) {
            filters.type = type;
        } else {
            filters.type = false;
        }

        _.each($desktopFilters, filter => {
            const $filter = $(filter);
            const name = $filter.attr('name');
            $filter.val(filters[name]);
            const $placeholder = $filter
                .parent()
                .find('.aam__select-placeholder')
                .first();
            const placeholder_text = $filter.parent().attr('data-placeholder');
            const text = $filter
                .find('option:selected')
                .text()
                .trim();
            const value = $filter.val();

            $placeholder.html(value ? text : placeholder_text);
        });

        $filteredEvents.trigger('filterChange');

        $mobile_filter_toggle[0].click();
    });

    $dayIncrementers.on('click', function(e) {
        e.preventDefault();

        if (filtering) {
            return;
        }

        incrementing = true;

        let { day, month, year } = filters.date;
        let nextDay;

        day = day >= 10 ? day : `0${day}`;
        month = month >= 10 ? month : `0${month}`;

        if ($(this).hasClass('--next')) {
            nextDay = moment(`${month}-${day}-${year}`, 'MM-DD-YYYY')
                .add(1, 'days')
                .format('MM-DD-YYYY');
        } else if ($(this).hasClass('--prev')) {
            nextDay = moment(`${month}-${day}-${year}`, 'MM-DD-YYYY')
                .add(-1, 'days')
                .format('MM-DD-YYYY');
        }

        const dayParts = nextDay.split('-').map(val => parseInt(val));

        filters.date = {
            day: dayParts[1],
            month: dayParts[0],
            year: dayParts[2],
        };

        $dayLabel.html(moment(nextDay, 'MM-DD-YYYY').format('MMMM D, YYYY'));

        $(
            '[data-placeholder="Filter by date"] > .aam__select-placeholder',
        ).html(moment(nextDay, 'MM-DD-YYYY').format('M/D/YYYY'));

        pickers.forEach((picker, i) => {
            picker.setDate(
                `${dayParts[0]}-${dayParts[1]}-${dayParts[2]}`,
                true,
            );
        });

        $filteredEvents.trigger('filterChange');
    });

    $clearDay.on('click', e => {
        e.preventDefault();

        filters.date = false;

        pickers.forEach((picker, i) => {
            picker.setDate(null);
        });

        $filteredEvents.trigger('filterChange');
    });
});
